import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react'; 
import { useLocation, useNavigate } from 'react-router-dom'; 

import { useAuthContext } from '../../../context';
import { SubNivelAcesso } from '../../../services/api/users/UserServices';

interface IVMPlansAndProceduresProps {
	id: string;
}

export const VMPlansAndProcedures: React.FC<IVMPlansAndProceduresProps> = ({ id }) => {
	const navigate = useNavigate();
	const location = useLocation(); 
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));

	const { userData } = useAuthContext();

	const acompanhamentosPermissoes: SubNivelAcesso = useMemo(() => {
		return userData?.nivel_acesso?.acompanhamentos || {};
	}, [userData]); 

	const isButtonActive = (path: string) => {
		return location.pathname === path;
	};

	const hasPermission = (permissionValue: string | null | undefined): boolean => {
		return typeof permissionValue === 'string' && permissionValue !== '';
	};

	return (
		<Box
			display={'flex'}
			flexDirection={smDown ? 'column' : 'row'}
			width={'100%'}
		>
			<Box
				display={'flex'}
				flexDirection={'column'}
				alignItems={smDown ? 'center' : 'start'}
				width={smDown ? '100%' : '50%'}
				padding={1}
			>
				<Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registros Legais</Typography> 

				{/* {hasPermission(acompanhamentosPermissoes.treinamento_plan) && ( 
                    <Button variant={isButtonActive(`/information_dam/${id}/training_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/training_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de treinamento</Typography>
                    </Button>
                )} */}

				{/* {hasPermission(acompanhamentosPermissoes.operation_plan) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/operation_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de operação</Typography>
                    </Button>
                )} */}

				{hasPermission(acompanhamentosPermissoes.comunicacao) && (
					<Button variant={isButtonActive(`/information_dam/${id}/maintenance_planning`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/maintenance_planning`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Calendário</Typography>
					</Button>
				)}

				{hasPermission(acompanhamentosPermissoes.visualizacao) && (
					<Button variant={isButtonActive(`/information_dam/${id}/monitoring_instrumentation_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/monitoring_instrumentation_plan`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Visualização e instrumentação</Typography>
					</Button>
				)}

				{hasPermission(acompanhamentosPermissoes.inspecoes) && (
					<Button variant={isButtonActive(`/information_dam/${id}/dam_safety_inspections_planning`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/dam_safety_inspections_planning`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Inspeções de Segurança</Typography>
					</Button>
				)}

				{hasPermission(acompanhamentosPermissoes.anomalias) && (
					<Button variant={isButtonActive(`/information_dam/${id}/anomaly`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/anomaly`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Acompanhamento de Anomalias</Typography>
					</Button>
				)}

				{hasPermission(acompanhamentosPermissoes.plano) && ( 
					<Button variant={isButtonActive(`/action_plan/${id}/plans`) ? 'contained' : 'text'} onClick={() => navigate(`/action_plan/${id}/plans`)}>
						<Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de ação</Typography>
					</Button>
				)}

				{/* {hasPermission(acompanhamentosPermissoes.equipment_manuals_test_calibration_schedules) && ( // Exemplo de chave
                    <Button variant={isButtonActive(`/information_dam/${id}/equipment_manuals_test_calibration_schedules`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/equipment_manuals_test_calibration_schedules`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Manuais dos equipamentos com cronogramas de testes e calibração</Typography>
                    </Button>
                )} */}
			</Box>
			<Divider orientation={smDown ? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
			<Box
				display={'flex'}
				flexDirection={'column'}
				alignItems={smDown ? 'center' : 'start'}
				width={smDown ? '100%' : '50%'}
				padding={1}
			>
				{/* {hasPermission(acompanhamentosPermissoes.hse_geotechsustainability_policy) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/hse_geotechsustainability_policy`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/hse_geotechsustainability_policy`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Política de Saúde e segurança ocupacional, gestão geotécnica e sustentabilidade</Typography>
                    </Button>
                )}
                
                {hasPermission(acompanhamentosPermissoes.geotechnical_structures_management) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_structures_management`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_structures_management`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Padrão de gestão de estruturas geotécnicas</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.professional_training_plan) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/professional_training_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/professional_training_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de capacitação dos profissionais</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.risk_management_procedure) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/risk_management_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_management_procedure`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de gestão de risco</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.document_control_procedure) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/document_control_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/document_control_procedure`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de controle de documentos</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.current_legislation) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/current_legislation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/current_legislation`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Legislação vigente</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.change_management_procedure) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/change_management_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/change_management_procedure`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de gestão de mudanças</Typography>
                    </Button>
                )}
                
                {hasPermission(acompanhamentosPermissoes.quality_management_plan) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/quality_management_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/quality_management_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de gestão da qualidade</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.inspection_action_plan) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/inspection_action_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/inspection_action_plan`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de ação da inspeção</Typography>
                    </Button>
                )}

                {hasPermission(acompanhamentosPermissoes.geotechnical_resources_relation) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_resources_relation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_resources_relation`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relação dos recursos da geotecnia</Typography>
                    </Button>
                )} */}
			</Box>
		</Box>
	);
};